import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
  color?: 'primary' | 'gray'
}

const AttendanceModuleBrand: FC<Props> = ({ color = 'primary', size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    `${color}.200`,
    `${color}.300`,
    `${color}.400`,
    `${color}.500`,
    `${color}.600`,
    `${color}.700`,
    `${color}.900`,
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Atendimento">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M310.39,625.23c64.39,66.25,161.93,95.95,256.84,67.68C694,655.15,771.54,524,744.42,392.94c-.18-.87-.37-1.75-.56-2.62-7.92-36.42-6.91-74,1.51-110.18a156.13,156.13,0,0,0-2.56-80.24C719,119.79,635.15,72.49,555.33,93.93c-30.93,8.3-90.46,51-135.48,84.66C389.49,201.26,350,206.82,314.18,194.2a202,202,0,0,0-130.92-1.26c-99,32.58-157.76,137.24-135,240.16,21.18,96,104.28,160.82,196.13,162.92A95.34,95.34,0,0,1,310.39,625.23Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M665,230.89c5.21-36.46-9.18-74.47-41.23-97.53-42.81-30.81-103.1-23.3-137.83,17.18l-.69.82a99.81,99.81,0,0,1-35.14,26.37,62.36,62.36,0,0,0-24.69,20.36c-19.47,27-14,65,12.25,85,10.15,7.74,38.15,16.11,59.73,22.12,14.55,4.06,24.63,10.73,29.37,25.11,5.39,16.33,29.61,35.72,51.73,34.68,41.5-2,48.82-11.24,76.65-42.73,12.48-14.12,33.39-26.5,11.67-56C660.92,258.26,663.57,240.8,665,230.89Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M343.81,592.56C332,627.44,339.17,667.45,366.44,696c36.43,38.14,97.07,41.82,138.64,8.4l.83-.68a99.88,99.88,0,0,1,39.38-19.47,62.25,62.25,0,0,0,28-15.49c24.1-23,25.66-61.35,3.56-85.78-8.57-9.47-34.55-22.84-54.66-32.71-13.56-6.65-22.24-15.07-24.27-30.06-2.3-17.06-22.55-40.56-44.48-43.59-41.16-5.69-50.06,2.08-83.19,27.93-14.86,11.6-37.69,19.93-21.76,52.91C352.83,566.4,347,583.08,343.81,592.56Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M113.12,319.57C81,337.54,59.47,372,60.56,411.5c1.47,52.73,44,96.11,97.25,99.18l1.07.05a100,100,0,0,1,42.27,11.95A62.36,62.36,0,0,0,232.32,530c33.31-.92,60.17-28.32,60.15-61.27,0-12.77-10.33-40.1-18.64-60.91-5.6-14-6.4-26.09,2.15-38.58,9.73-14.19,10.46-45.2-3.78-62.16-26.73-31.82-38.55-32-80.46-35-18.8-1.36-41.32-10.49-51.61,24.67C137.34,306.21,121.86,314.69,113.12,319.57Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M390.67,618.6c55.57,59.61,181.48,27.5,246.62-30.69,87-77.75,38-276.55,37.87-277.32-8.19-48.1,9.21-80.85-26.61-128.94-13.82-18.55-39.91-44-87-43-73.72,1.6-64.82,31.82-128.94,66.52-87,47.07-124.84,22.51-213.87,64.46-45.14,21.28-80.7,60.19-89,108.48-15.63,90.59,16,152.06,89,187.26C276.06,593,334.39,558.23,390.67,618.6Z"
              />
              <path
                fill={fillColor600}
                d="M142.08,642.56a29.45,29.45,0,0,0,27,16.61,11.86,11.86,0,0,1,11,7.27c.1.21.19.42.3.64a14,14,0,0,0,11.8,8.12,14.6,14.6,0,0,0,15.17-18.69,14.34,14.34,0,0,0-3.65-6.14,19.86,19.86,0,0,1-5.87-16.7,29.48,29.48,0,1,0-55.73,8.89Z"
              />
              <path
                fill={fillColor600}
                d="M733.3,622c-8.3,31-46.6,22.92-39.49,10.81C706,612,690.5,609.91,696,597s27-19,28.9-20.2C742,566,745.77,575.34,733.3,622Z"
              />
              <path
                fill={fillColor600}
                d="M698.87,109.71a14.89,14.89,0,0,1-20,22.08c-6.1-5.52-18.14-14.36-12.62-20.46S692.78,104.19,698.87,109.71Z"
              />
            </g>
          </g>
          <g id="icon">
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M416,580.4l-83,42.71V547.18c-52.2-38-85.42-92.54-85.42-156.61C247.56,283.8,342.47,196,461.11,196s213.56,85.42,213.56,194.57h0c0,106.78-94.92,194.58-213.56,194.58-14.24,0-30.85-2.38-45.08-4.75"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M553.65,447.52c-52.2,52.2-135.25,52.2-187.45,0"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M413.65,328.88v23.73"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M508.57,328.88v23.73"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(AttendanceModuleBrand)
